import React from 'react';
import { Footer } from '../components/Footer';
import { motion } from 'framer-motion';
const experiences = [{
  title: 'Sports Bar Experience',
  description: 'Catch every major game on our premium screens with game-day specials and an electric, high-energy atmosphere.',
  image: 'https://images.unsplash.com/photo-1612872087720-bb876e2e67d1?auto=format&fit=crop&q=80&w=800'
}, {
  title: 'Comedy Nights',
  description: 'Laugh out loud with local legends and touring comedians in an intimate, sophisticated lounge setting.',
  image: 'https://images.unsplash.com/photo-1585699324551-f6c309eedeca?auto=format&fit=crop&q=80&w=800'
}, {
  title: 'Happy Hour',
  description: 'Unwind after work with exclusive pricing on our signature crafted cocktails and boutique bar bites.',
  image: 'https://images.unsplash.com/photo-1514362545857-3bc16c4c7d1b?auto=format&fit=crop&q=80&w=800'
}, {
  title: "Ladies' Night",
  description: 'An exclusive evening dedicated to elegance, featuring specially curated drinks and vibrant DJ sets.',
  image: 'https://images.unsplash.com/photo-1566737236500-c8ac43014a67?auto=format&fit=crop&q=80&w=800'
}, {
  title: 'Nightlife Ambience',
  description: "When the sun goes down, District 14 transforms into DC's premier boutique nightlife destination.",
  image: 'https://images.unsplash.com/photo-1574096079513-d8259312b785?auto=format&fit=crop&q=80&w=800'
}];
export function Nightlife() {
  return <main className="bg-obsidian min-h-screen" data-id="element-240">
      <div className="pt-24 md:pt-28 pb-16 px-6 md:px-8 max-w-7xl mx-auto" data-id="element-241">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="text-center mb-12 md:mb-16" data-id="element-242">
          <h1 className="text-5xl md:text-8xl font-serif text-champagne mb-6" data-id="element-243">
            NIGHTLIFE
          </h1>
          <p className="text-white/60 font-sans text-xl md:text-2xl max-w-2xl mx-auto" data-id="element-244">
            The pulse of DC. From high-energy sports to exclusive late-night
            vibes.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-12" data-id="element-245">
          {experiences.map((exp, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="group cursor-pointer" data-id="element-246">
              <div className="relative aspect-[4/5] overflow-hidden mb-6 border border-white/5" data-id="element-247">
                <img src={exp.image} alt={exp.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-248" />
                <div className="absolute inset-0 bg-obsidian/40 opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-249" />
                <div className="absolute inset-0 border-0 group-hover:border-[1px] border-crimson transition-all duration-500 z-10" data-id="element-250" />
              </div>
              <h3 className="text-2xl font-serif text-white mb-3 group-hover:text-crimson transition-colors" data-id="element-251">
                {exp.title}
              </h3>
              <p className="text-white/50 font-sans text-lg leading-relaxed" data-id="element-252">
                {exp.description}
              </p>
            </motion.div>)}
        </div>
      </div>
      <Footer data-id="element-253" />
    </main>;
}